import { render } from "./PreviewComp.vue?vue&type=template&id=0e45d7cf&scoped=true"
import script from "./PreviewComp.vue?vue&type=script&lang=js"
export * from "./PreviewComp.vue?vue&type=script&lang=js"

import "./PreviewComp.vue?vue&type=style&index=0&id=0e45d7cf&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0e45d7cf"]])

export default __exports__